module.exports = __webpack_public_path__ + "static/media/first.13ca34a5.jpeg";